module.exports = __webpack_public_path__ + "img/people.cb128475.svg";